module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNDgwIiB3aWR0aD0iNjQwIiB2aWV3Qm94PSIwIDAgNjQwIDQ4MCI+CiAgPGcgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgIDxwYXRoIGZpbGw9IiMwMGNkMDAiIGQ9Ik00MjYuODMgMEg2NDB2NDgwSDQyNi44M3oiLz4KICAgIDxwYXRoIGZpbGw9IiNmZjlhMDAiIGQ9Ik0wIDBoMjEyLjg4djQ4MEgweiIvPgogICAgPHBhdGggZmlsbD0iI2ZmZiIgZD0iTTIxMi44OCAwaDIxMy45NXY0ODBIMjEyLjg4eiIvPgogIDwvZz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/4x3/ci.svg
// module id = ./node_modules/flag-icon-css/flags/4x3/ci.svg
// module chunks = 0